import { useEffect, useCallback, useState, useRef } from "react";
import { Card, Col, Row } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import { Modal, Title } from "components";
import { useAppDispatch, useAppSelector } from "redux/hooks";
import { RootState } from "redux/store";
import { getStores } from "redux/slices/Stores";
import { getPreferredBrands, updatePreferredBrandField, deletePreferredBrand, cleanPreferredBrands, addAGGridSelectedRows } from "redux/slices/PreferredBrands";
import { AgGridReact } from "ag-grid-react";
import BaseCellRenderer from "components/AgGrid/CellRenderers/BaseCellRenderer";
import { getPreferredBrandsConfig } from "TableConfigs/PreferredBrandsConfig";
import { AgGridToolbar, AgGridToolbarRef } from "components/AgGrid/AgGridToolbar";
import { ZTooltip } from "components/ZTooltip";
import { Z } from "models/common/components";
import { ZIconType } from "helpers/utility/iconMap";


export function PreferredBrands() {
	const navigate = useNavigate();
	const dispatch = useAppDispatch();
	const preferredBrands: any = useAppSelector((state: RootState) => state.preferredBrands);
	const currentStoreGroupId = useAppSelector((state: RootState) => state.global.storeGroupId);
	const user = useAppSelector((state: RootState) => state.logedinUser);
	const preferredBrandsGridRef = useRef<AgGridReact>(null);
	const toolbarRef = useRef<AgGridToolbarRef>(null);
	const [ showDelete,setShowDelete] = useState<boolean>(false); 

	useEffect(() => {
		dispatch(getPreferredBrands({}));
		dispatch(cleanPreferredBrands());
		dispatch(getStores({ storeGroupIds: [currentStoreGroupId] }));
	}, []);

	function handleDelete() {
		let preferredBrandIds = preferredBrands.selectedRows.map((row: any) => row.id );
		dispatch(deletePreferredBrand(preferredBrandIds)).then(() => {
			dispatch(getPreferredBrands({}));
		});
	}

	return (
		<>
			<Title pageTitle="Preferred Brands" />
			<Row>
				<Col xs={12}>
					<Card>
						<Card.Body>
							<Row className="mb-1">
								<div className="page-container">
									<AgGridToolbar 
										search={true}
										ref={toolbarRef}
										className="pb-1"
										handleSubmit={(searchState, filterState) => {
											preferredBrandsGridRef.current?.api.setGridOption('quickFilterText', searchState?.keyword);
										}}
										handleClearFilters={() => {															
										}}													
										searchProps={
											{placeholder: "by Name", totalRows: preferredBrands.table.length, hideContains: true}
										}
										children={(<div className="d-inline-flex gap-1">
											{ 
											(preferredBrands.selectedRows != undefined && preferredBrands.selectedRows.length != 0) &&									
												<Z.Button variant="light" className="h-100" disabled={true} buttonText={preferredBrands.selectedRows.length+ " Selected"}/>
											}
											<ZTooltip text="Add">
												<Z.Button icon={ZIconType.Add} buttonSize="md" onClick={() => user.permissions.preferredBrands.canCreate ? navigate("/app/preferred-brand/new") : undefined }/>
												</ZTooltip>
											<ZTooltip text={
												preferredBrands.selectedRows.length == 0? `Please select a row to delete`:
												preferredBrands.selectedRows.length == preferredBrands.table.length ? `Delete all rows`:									  
												preferredBrands.selectedRows.length> 0 ? `Delete ${preferredBrands.selectedRows.length} rows` :                                                    
												"Please select a row to delete"}>
												<Z.Button icon={ZIconType.Delete} buttonSize="md"  onClick={() => (user.permissions.preferredBrands.canDelete ? setShowDelete(true) : undefined)} 
													disabled={!user.permissions.preferredBrands.canDelete || preferredBrands.selectedRows.length < 1} />
											</ZTooltip>
											<ZTooltip text="Refresh">
												<Z.Button icon={ZIconType.Refresh} buttonSize="md" onClick={() => dispatch(getStores({ storeGroupIds: [currentStoreGroupId] })).then((res) => {
													if(res.totalRows == 0){
														preferredBrandsGridRef.current?.api.showNoRowsOverlay()
													}
												})}
												disabled={!user.permissions.preferredBrands.canView} />
											</ZTooltip>										
										</div>
										)}
									/>

									<AgGridReact
										ref={preferredBrandsGridRef} 
										columnDefs={getPreferredBrandsConfig()}
										pagination={true}
										paginationPageSize={20}
										containerStyle={{ height: "75dvh" }}
										className="ag-theme-quartz ag-theme-custom w-100"
										rowSelection="multiple"
										suppressRowClickSelection={true}
										singleClickEdit
										stopEditingWhenCellsLoseFocus={true}
										rowData={preferredBrands.table}						
										suppressContextMenu										
										components={{
											baseCellRenderer: BaseCellRenderer,
										}}
										onSelectionChanged={(e) => {
											let formatedData:{
												positon: number,
												id: number
											} [] = [];
											preferredBrandsGridRef.current?.api.getSelectedRows().forEach((xe: any) => formatedData.push({ positon: 0, id: xe.id}));
											dispatch(addAGGridSelectedRows(formatedData));
										}}
									/>
								</div>
							</Row>
						</Card.Body>
					</Card>
				</Col>
			</Row>
			 <Modal
                title="Confirm Delete"
                show={showDelete}
                buttonType="primary"
                buttonText={"Continue"}
                buttonCloseText="Cancel"
                handleSubmit={() => {
                    handleDelete();
                    setShowDelete(false);
                    preferredBrandsGridRef.current?.api.deselectAll();
                    preferredBrandsGridRef.current?.api.refreshServerSide();
                }}
                handleClose={() => setShowDelete(false)}
                description={
                    <>
                        <p>You are about to delete {preferredBrands.selectedRows.length} selected {preferredBrands.selectedRows.length > 1 ? "items": "item"}.</p>
                        <p>Are you sure you want to delete?</p>
                    </>
                }
            />
		</>
	);
}